// src/pages/usa/puertorico/CaboRojo.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Cabo Rojo ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function CaboRojo() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Cabo Rojo, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Cabo Rojo, Puerto Rico</h2>

            <p>
              Cabo Rojo, located on the southwestern coast of Puerto Rico, is a hidden gem
              known for its stunning beaches, dramatic cliffs, and vibrant culture. Whether
              you're seeking relaxation on pristine sands or adventure in nature reserves,
              Cabo Rojo offers a diverse range of experiences for every traveler.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Cabo Rojo is accessible by car from San Juan in about 2.5–3 hours via PR‑2
              and PR‑100. The nearest airport is Rafael Hernández Airport (BQN) in
              Aguadilla, roughly one hour away.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Cabo Rojo Lighthouse:</strong> Perched atop dramatic cliffs with
                  breathtaking views of the Caribbean Sea. The area includes a coastal cave
                  below the lighthouse and the famous salt flats nearby. Vehicle access is
                  no longer allowed — visitors must walk about 2 miles each way. Playa
                  Sucia, despite its name, is one of the most beautiful beaches in Puerto
                  Rico.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.933669130248,-67.1924652633302"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>El Poblado / Combate:</strong> A laid‑back beach town with
                  restaurants, bars, and shops. Perfect for swimming, sunsets, and relaxing
                  by the water.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.982213774893367,-67.21430784297499"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Boquerón:</strong> A lively beach town with nightlife, a
                  beautiful bay, and access to the Boquerón State Forest. More touristy
                  than Combate, but full of energy.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.025122482733494,-67.17385197778694"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems – Cabo Rojo</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Playa Buyé:</strong> Calm, crystal‑clear waters and shaded palms.
                  A local favorite with quiet coves beyond the main beach.
                  <br />
                  <a
                    href="https://caborojopr.com/playa-buye-beach-cabo-rojo-puerto-rico/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    🌐 Full Beach Guide
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Laguna Guaniquilla:</strong> A nature reserve with limestone
                  formations, mangroves, and ruins of a 19th‑century hacienda. Great for
                  photographers and hikers.
                  <br />
                  <a
                    href="https://www.puertoricodaytrips.com/laguna-guaniquilla/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    🌐 Explore the Reserve
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Villa La Mela:</strong> Rustic beachfront cabins in Barrio
                  Guaniquilla. Family‑run, peaceful, and perfect for disconnecting.
                  <br />
                  <a
                    href="https://villalamela.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    🌐 Visit Villa La Mela
                  </a>
                </div>
              </li>
            </ul>

            <h3>🛏️ Places to Stay in Cabo Rojo</h3>

            <p>
              Cabo Rojo offers excellent lodging near beaches, nature reserves, and
              nightlife. I try to keep this list accurate, but always double‑check with
              Expedia or Booking.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Combate Beach Resort:</strong> Family‑owned eco‑resort with
                  direct beach access, pool, and on‑site dining.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Luichy’s Seaside Hotel:</strong> Stylish, pet‑friendly, and
                  located right on Playa El Combate.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Aquarius Vacation Club at Boquerón:</strong> Beachfront hotel
                  with pool, hot tub, and family‑friendly amenities.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Blue House Joyuda:</strong> Boutique stay with ocean views and
                  modern design.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Parador Boquemar:</strong> Budget‑friendly inn near nightlife and
                  restaurants.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hacienda Tres Casitas:</strong> Rustic B&B in the hills with
                  panoramic views.
                </div>
              </li>
            </ul>

           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I took in Cabo Rojo. Set the quality to 1080p or higher
              for best viewing.
            </p>

            <p>
              <a
                href="https://youtu.be/kBKzM9VI3Q8?si=97q6oWXRNut1vlUE"
                target="_blank"
                rel="noopener noreferrer"
              >
                Las Salinas
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/QRpOkw0y540?si=xyFCeA9AVx0kxGRg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Lighthouse Trail
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/WJyxKEtiqjI?si=qQwb9c9BMOIhoBos"
                target="_blank"
                rel="noopener noreferrer"
              >
                Jaguey Cave Trail
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/neVJE5Kpzi8?si=L9hHF6-mNJRLQb2d"
                target="_blank"
                rel="noopener noreferrer"
              >
                Poblado de Boquerón
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/kBKzM9VI3Q8?si=97q6oWXRNut1vlUE"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/caborojo/lassalinas.jpg"
                alt="Las Salinas Video"
              />
            </a>

            <a
              href="https://youtu.be/WJyxKEtiqjI?si=zB4Zp9vwX1J1Eabu"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/caborojo/cave.jpg"
                alt="Jaguey Cave Video"
              />
            </a>

            <a
              href="https://youtu.be/neVJE5Kpzi8?si=GHPCkUoFjfNTQL4c"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/caborojo/boqueron.jpg"
                alt="Boquerón Video"
              />
            </a>

            <img
              src="/images/usa/puertorico/caborojo/thelighthouse.jpg"
              alt="Cabo Rojo Lighthouse"
            />
            <img
              src="/images/usa/puertorico/caborojo/lighthousecliff.jpg"
              alt="Lighthouse Cliff View"
            />
            <img
              src="/images/usa/puertorico/caborojo/thearch.jpg"
              alt="The Arch"
            />
            <img
              src="/images/usa/puertorico/caborojo/lagunaguaniquilla.jpg"
              alt="Laguna Guaniquilla"
            />
            <img
              src="/images/usa/puertorico/caborojo/villalamela.jpg"
              alt="Villa La Mela"
            />
            <img
              src="/images/usa/puertorico/caborojo/theflag.jpg"
              alt="Puerto Rico Flag"
            />
            <img
              src="/images/usa/puertorico/caborojo/thebeach.jpg"
              alt="The Beach"
            />
            <img
              src="/images/usa/puertorico/caborojo/viewfromtower.jpg"
              alt="View From Tower"
            />
            <img
              src="/images/usa/puertorico/caborojo/saltmountain.jpg"
              alt="Salt Mountain"
            />
            <img
              src="/images/usa/puertorico/caborojo/pinksaltpool.jpg"
              alt="Pink Salt Pool"
            />

            {/* 360° Embed */}
<div style={{ maxWidth: "800px", margin: "auto" }}>
  <iframe
    title="Jaguey Cave 360 View"
    width="100%"
    height="500"
    allowFullScreen
    style={{ border: "none" }}
    src="https://momento360.com/e/u/7c0fe5f42323480a8f790fa7838ae286?utm_campaign=embed&utm_source=other&heading=-220.74&pitch=-0.75&field-of-view=100&size=medium&display-plan=true"
  ></iframe>
</div>

<p style={{ textAlign: "center" }}>
  <em>Explore Jaguey Cave in immersive 360° — captured by Edgardo</em>
</p>
</div>
</section>
</div>

<div className="email-wrapper">
  <button className="email-link" onClick={() => setOpen(true)}>
    contact@thefindingspot.com
  </button>
</div>

<ContactPopup isOpen={open} onClose={() => setOpen(false)} />

<Footer />
</>
);
}
